import { TypedDefinition } from '@rehaje/core'

import type { ElementPlugin } from './plugin'
import type { TypedSchema } from '@rehaje/core'

export class ElementDefinition extends TypedDefinition {
  override properties: TypedSchema[] = [
    {
      name: 'type',
      type: 'Schema.String'
    },
    {
      name: 'id',
      type: 'Schema.String'
    },
    {
      name: 'name',
      type: 'Schema.String'
    },
    {
      name: 'props',
      type: 'Schema.Object'
    },
    {
      name: 'hidden',
      type: 'Schema.Boolean'
    },
    {
      items: {
        type: 'Schema.Element'
      },
      name: 'children',
      type: 'Schema.Array'
    },
    {
      name: 'setHidden',
      parameters: [
        {
          name: 'hidden',
          type: 'Schema.Boolean'
        }
      ],
      type: 'Schema.Function'
    }
  ]

  override relationTo = 'Schema.Element'
  get plugin() {
    return this.getPlugin<ElementPlugin>()
  }
}
